import "./ContactUs.css";
import useSaveContactMessage from "../../hooks/useSaveContactMessage";

export default function ContactUs() {

    const { saveContactMessage } = useSaveContactMessage();

    const handleSubmit = async (e) => {
        e.preventDefault();

        const name = e.target.name.value;
        const email = e.target.email.value;
        const message = e.target.message.value;

        try {
            await saveContactMessage({ name, email, message });

            alert("Thank you! Your message has been submitted.");
            e.target.reset();

        } catch (err) {
            alert("Something went wrong. Please try again.");
        }
    };

    return (
        <div className="contact-container">

            <section className="contact-hero">
                <h1 className="contact-title">Contact Us</h1>
                <p className="contact-subtitle">
                    Have questions or need help? We're here for you.
                </p>
            </section>

            <div className="contact-grid">

                <div className="contact-info">
                    <h2>Get in Touch</h2>
                    <p className="info-text">
                        If you have any questions about Interview Buster or need support, feel free to reach out.
                    </p>

                    <div className="info-item">
                        <span className="info-label">📧 Email</span>
                        <p className="info-detail">contact@glimsiaglobal.com</p>
                    </div>

                    <div className="info-item">
                        <span className="info-label">📍 Address</span>
                        <p className="info-detail">India</p>
                    </div>

                    <div className="info-item">
                        <span className="info-label">⏰ Support Hours</span>
                        <p className="info-detail">All Days(9 AM – 7 PM)</p>
                    </div>
                </div>

                <form className="contact-form" onSubmit={handleSubmit}>
                    <h2>Send Us a Message</h2>

                    <label>Your Name</label>
                    <input name="name" type="text" placeholder="John Doe" required />

                    <label>Your Email</label>
                    <input name="email" type="email" placeholder="you@example.com" required />

                    <label>Your Message</label>
                    <textarea name="message" placeholder="Write your message..." rows="5" required />

                    <button type="submit" className="contact-btn">
                        Submit Message
                    </button>
                </form>

            </div>
        </div>
    );
}
